import { TrendingUpIcon } from "./Icons/trendingUpIcon";
import { CourseLayout } from "./courseLayout";
import { useTranslation } from "react-i18next";
import { Flex, Spinner } from "@chakra-ui/react";
import {
  CardContainer,
  HeaderSection,
  TrendingTitle,
  SubText,
  NoCourseText,
  StartLearningButton,
  StartLearningText,
  CourseListSection,
} from "./style";
import useMediaQ from "@root/hooks/useMediaQ";

interface RecentLearningProps {
  courses: any[];
  loading?: boolean;
}

export const RecentLearning = ({
  courses,
  loading = false,
}: RecentLearningProps) => {
  const { t } = useTranslation("common");
  const { sm } = useMediaQ();
  const isMobile = !sm;

  const renderContent = () => {
    if (loading) {
      return (
        <Flex justify="center" align="center" minHeight="200px">
          <Spinner size="lg" />
        </Flex>
      );
    }

    if (!courses || courses?.length === 0) {
      return (
        <Flex
          width="100%"
          flexDirection="column"
          gap={4}
          alignItems="center"
          justifyContent="center"
          minHeight="180px"
          px={4}
        >
          <NoCourseText>{t("kpecDashboard.noCourseInProgress")}</NoCourseText>
          <StartLearningButton>
            <StartLearningText>
              {t("kpecDashboard.startLearning")}
            </StartLearningText>
          </StartLearningButton>
        </Flex>
      );
    }

    return (
      <CourseListSection maxH={isMobile ? "300px" : "340px"} overflowY={"auto"}>
        {courses?.map((course, idx) => (
          <CourseLayout
            key={idx}
            id={course?.course?.id}
            name={course?.course?.title}
            completed={course?.progress}
          />
        ))}
      </CourseListSection>
    );
  };

  return (
    <CardContainer data-tour-item="journalist-recent-learning">
      <HeaderSection width="100%" height="auto" p={4} gap={2}>
        <Flex alignItems="center" gap={2}>
          <TrendingUpIcon />
          <TrendingTitle>{t("kpecDashboard.recentlearning")}</TrendingTitle>
        </Flex>
        <SubText px={0} fontSize="14px">
          {t("kpecDashboard.checkyourinprogressorcompletedcourses")}
        </SubText>
      </HeaderSection>

      {renderContent()}
    </CardContainer>
  );
};
